import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'src/app/services/admin.service';
import { Table } from 'primeng/table/table';
import { SelectItem } from 'primeng/api/selectitem';
import { MenuItem } from 'primeng/api/menuitem';
import { Menu } from 'primeng/menu/menu';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { User } from 'src/app/intefaces/user.interface';
import { UserSearchParams } from 'src/app/intefaces/user-search-params.interface';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers: [ConfirmationService]
})
export class UsersComponent implements OnInit {

  users: User[] = [];
  loading: boolean;
  userRoles: SelectItem[];
  functionsMenu: MenuItem[] = [];
  blockSellingNotes: boolean = false;
  showBlockSellingNotesBtn: boolean = false;
  rowsOnPage: number = 100;
  totalRecords: number;
  page: number = 0;
  first: number = 0;
  showFilters: boolean = false;
  searchParams: UserSearchParams = {};

  @ViewChild('tt') table: Table;
  @ViewChild('menu') menu: Menu;

  constructor(
    private translate: TranslateService,
    private adminService: AdminService,
    private confirmationService: ConfirmationService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.loadUsers();
    this.translate.onLangChange.subscribe(lang => {
      this.initRoles();
    });
    this.initRoles();
  }

  public onToggleFilters(): void {
    this.showFilters = this.showFilters ? false : true;
  }

  private initRoles(): void {
    this.translate.get(['all_users', 'only_arangers', 'only_customers', 'only_admins']).subscribe(t => {
      setTimeout(() => {
        this.userRoles = [
          { label: t.all_users, value: 'all' },
          { label: t.only_arangers, value: 'arranger' },
          { label: t.only_customers, value: 'customer' },
          { label: t.only_admins, value: 'admin' },
        ];
      });
    })
  }

  public onLoadUsersLazy(event: any): void {
    this.loading = true;
    this.page = event.first / event.rows;
    this.rowsOnPage = event.rows;
    this.loadUsers();
  }

  public loadUsers(): void {
    this.adminService.getUserSearch(this.searchParams, this.page, this.rowsOnPage).subscribe((response: any) => {
      this.users = response.data.users;
      if (this.page == 0) {
        this.totalRecords = response.data.total;
      }
      this.loading = false;
    });
  }

  public goToFullDetails(id: number): void {
    const user = this.getUser(id);
    this.router.navigate(['/administrator-panel/user-full-details', id, user.user_details.role])
  }

  public onSearchUsers(): void {
    this.loading = true;
    this.page = 0;
    this.first = 0;
    this.loadUsers();
  }

  public onRefreshSearch() {
    this.searchParams = {};
    this.onSearchUsers();
  }

  public onPopulateFunctionsMenu(event: any, id: number): void {

    this.translate.get(['show_user_details', 'block_account', 'unblock_account', 'remove_arranger', 'remove_admin', 'add_arranger', 'add_admin']).subscribe(t => {
      this.functionsMenu = [];
      const user = this.getUser(id);

      this.functionsMenu.push({ label: t.show_user_details, command: (click) => { this.goToFullDetails(id) } });

      if (user.user_details.is_active == true) {
        this.functionsMenu.push({ label: t.block_account, command: (click) => { this.onBlockAccount(id) } });
      } else {
        this.functionsMenu.push({ label: t.unblock_account, command: (click) => { this.onUnblockAccount(id) } });
      }

      if (user.user_details.role == 'arranger') {
        this.functionsMenu.push({ label: t.remove_arranger, command: (click) => { this.onRemoveFromArrangers(id) } });
      } else if (user.user_details.role == 'admin') {
        this.functionsMenu.push({ label: t.remove_admin, command: (click) => { this.onRemoveFromAdministrator(id) } });
      } else {
        this.functionsMenu.push({ label: t.add_arranger, command: (click) => { this.onAddToArrangers(id) } });
        this.functionsMenu.push({ label: t.add_admin, command: (click) => { this.onAddToAdministrators(id) } });
      }

      this.menu.toggle(event);
    });
  }

  public onBlockAccount(id: number): void {
    const user = this.getUser(id)
    if (user.user_details.role == 'arranger') {
      this.showBlockSellingNotesBtn = true;
      this.blockSellingNotes = false;
    }
    this.translate.get('block_user_confirmation').subscribe(t => {
      this.confirmationService.confirm({
        message: t,
        accept: () => {
          this.adminService.blockUser(id).subscribe(
            data => {
              if (data.data == 'ok') {
                user.user_details.is_active = false;
              }
            }
          );
          if (this.blockSellingNotes == true) {
            this.adminService.blockSellingNotes(id).subscribe();
          }
          this.showBlockSellingNotesBtn = false;
        },
        reject: () => {
          this.showBlockSellingNotesBtn = false;
        }
      });
    })
  }

  public onUnblockAccount(id: number): void {
    this.translate.get('unblock_user_confirmation').subscribe(t => {
      this.confirmationService.confirm({
        message: t,
        accept: () => {
          this.adminService.unblockUser(id).subscribe(
            data => {
              if (data.data == 'ok') {
                const user = this.getUser(id)
                user.user_details.is_active = true;
              }
            }
          );
        }
      });
    });
  }

  public onAddToArrangers(id: number): void {
    this.translate.get('confirm_add_to_arrangers').subscribe(t => {
      this.confirmationService.confirm({
        message: t,
        accept: () => {
          this.adminService.addToArrangers(id).subscribe(
            data => {
              if (data.message == 'OK') {
                const user = this.getUser(id)
                user.user_details.role = 'arranger';
              }
            }
          );
        }
      });
    });
  }

  public onRemoveFromArrangers(id: number): void {
    this.showBlockSellingNotesBtn = true;
    this.blockSellingNotes = false;
    this.translate.get('confirm_remove_from_arrangers').subscribe(t => {
      this.confirmationService.confirm({
        message: t,
        accept: () => {
          this.adminService.removeFromArrangers(id).subscribe(
            data => {
              if (data.message == 'OK') {
                const user = this.getUser(id)
                user.user_details.role = 'customer';
              }
            }
          );
          this.showBlockSellingNotesBtn = false;
        },
        reject: () => {
          this.showBlockSellingNotesBtn = false;
        }
      });
    })
  }

  public onAddToAdministrators(id: number): void {
    this.translate.get('confirm_add_to_admins').subscribe(t => {
      this.confirmationService.confirm({
        message: t,
        accept: () => {
          this.adminService.addToAdministrators(id).subscribe(
            data => {
              if (data.message == 'OK') {
                const user = this.getUser(id)
                user.user_details.role = 'admin';
              }
            }
          );
        }
      });
    });
  }

  public onRemoveFromAdministrator(id: number): void {
    this.translate.get('confirm_remove_to_admins').subscribe(t => {
      this.confirmationService.confirm({
        message: t,
        accept: () => {
          this.adminService.removeFromAdministrators(id).subscribe(
            data => {
              if (data.message == 'OK') {
                const user = this.getUser(id)
                user.user_details.role = 'customer';
              }
            }
          );
        }
      });
    })
  }

  public getUser(id: number): User {
    let _user: User = null;
    for (let i = 0; i < this.users.length; i++) {
      if (this.users[i].id == id) {
        _user = this.users[i];
      }      
    }    
    return _user;
  }


}
